<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4">ACKNOWLEDGEMENTS</h4>
<p class="normal">Several years before the Irene Izak murder investigation came back to life in 1998, a state police investigator took me into his confidence, telling me his beliefs about who murdered Irene on Wellesley Island. His hope, never realized, was to at least make an attempt to close the case.</p>
<p class="bodytext">Nowhere in these pages does his name appear, at his insistence. But to him I credit the planting of the seed, giving me the inspiration to move on with a story that has haunted former members of the New York State Police, several of whom have echoed his words and encouragement to me.</p>
<p class="bodytext">This project would never have been accomplished had it not been for the information shared with me by Raymond O. Polett and his former investigative partner, the late Charles Donoghue, as well as private investigator Gus Papay. I salute their commitment.</p>
<p class="bodytext">Equally vital to this accomplishment was the assistance of Irene’s sisters, Helen Ewasko and Luba Boyko; their brother, Zenon George; Helen’s husband, Paul; and one of their daughters, Lisa Caputo. Their patience with my procrastinations, their endurance through my insistence for details and their understanding in the face of my mood swings and tantrums exemplify the beauty that lies within their hearts and souls.</p>
<p class="bodytext">To my team of copyeditors at the <i>Watertown Daily Times</i>—Mary Lu White, Patience O’Riley, Diana Staie and Cathie Egan—goes my thanks for reviewing my raw copy, making constructive suggestions and insisting that I learn the difference between “that” and “which.” Mary Lu in particular has my appreciation for the interest, concern and moral support that she so kindly offered.</p>
<p class="bodytext">Transcribing voice recordings to paper, Zona Gale Sweeney simplified my task in bringing together the story that unravels in the pages that follow.</p>
<p class="bodytext">And finally, there was my wife, Lucille, who challenged my stubborn lack of confidence, insisting that I could get the job done. It took a while, but hopefully I rewarded her confidence in me. </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_9781614230755_Acknowledgements.vue?4788af28